import "./App.css";
import { useEffect, useState } from "react";
import {
  createBrowserRouter,
  createHashRouter,
  RouterProvider,
  useLocation,
} from "react-router-dom";
import ProtectedRoutes from "./utility/ProtectedRoute";
import AuthContext from "./auth/context";
import storage from "./auth/storage";
import { jwtDecode } from "jwt-decode";

import Layout from "./components/Layout";
import LoginPage from "./routes/LoginPage";
import Dashboard from "./routes/Dashboard";
import Users from "./routes/Users";
import Page404 from "./routes/404";
import MachineDetail from "./routes/MachineDetail";
import ServerLogs from "./routes/ServerLogs";
import CommesseHistory from "./routes/CommesseHistory";
/*import Page404 from "./routes/404";
import LoginPage from "./routes/LoginPage";
import Industria40 from "./routes/Industria4.0";
import Industria40MachinePage from "./routes/Industria4.0MachinePage";

import Ordini from "./routes/Ordini";
import Clienti from "./routes/Clienti";
import AggiungiCliente from "./routes/AggiungiCliente";
import Lavorazioni from "./routes/Lavorazioni";
import Operators from "./routes/Operators";
import StatiOrdiniLavorazioni from "./routes/settings/StatiOrdiniLavorazioni";*/

function App() {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  const restoreUser = async () => {
    const token = await storage.getToken();
    setLoading(false);
    if (!token) return setUser();

    if (jwtDecode(token).exp < Date.now() / 1000) {
      await storage.removeToken();
      return setUser();
    }
    setUser(jwtDecode(token));
  };

  useEffect(() => {
    restoreUser();
  }, []);
  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }, [pathname]);

    return null;
  }

  const router = createBrowserRouter([
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      element: <ProtectedRoutes user={user} scrollToTop={<ScrollToTop />} />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },

        {
          path: "/operatori",
          element: user?.role == "admin" ? <Users /> : <Page404 />,
        },
        {
          path: "/machine/:id",
          element: <MachineDetail />,
        },
        {
          path: "/server-logs",
          element: <ServerLogs />,
        },
        {
          path: "/commesse/:machineName",
          element: <CommesseHistory />,
        },
        /*
        {
          path: "/industria4.0",
          element: <Industria40 />,
        },
        {
          path: "/industria4.0/:slug",
          element: <Industria40MachinePage />,
       */
      ],
    },
    {
      path: "*",
      element: <Page404 />,
    },
  ]);

  if (!loading)
    return (
      <AuthContext.Provider value={{ user, setUser }}>
        <RouterProvider router={router} />
      </AuthContext.Provider>
    );
}

export default App;
